"use client";

import { Compass, Stamp, Scale, FileText, Briefcase, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OrganizationalServices() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const primaryServices = [{
    numeral: "i",
    title: "Profil & Konstitusi",
    description: "Menyajikan landasan ideologis dan konstitusional yang menjadi pedoman utama organisasi ABADI.NEWS.",
    Icon: Compass
  }, {
    numeral: "ii",
    title: "Mandat & Komando",
    description: "Informasi resmi mengenai garis instruksi dan kebijakan strategis yang dijalankan oleh pimpinan organisasi.",
    Icon: Stamp
  }, {
    numeral: "iii",
    title: "Hierarki Teritori",
    description: "Pemetaan struktur organisasi yang tersebar di berbagai wilayah untuk memastikan jangkauan informasi nasional.",
    Icon: Scale
  }];
  const secondaryServices = [{
    numeral: "iv",
    title: "Unit Fungsional",
    description: "Berbagai badan dan lembaga sayap yang bergerak secara spesifik dalam mendukung operasional dan layanan publik.",
    Icon: FileText,
    span: "lg:col-span-7"
  }, {
    numeral: "v",
    title: "Warta & Layanan",
    description: "Pusat informasi kegiatan, aksi sosial, serta layanan masyarakat yang disediakan oleh organisasi kami.",
    Icon: Briefcase,
    span: "lg:col-span-5"
  }];
  return <section data-section-id="3568" id="organizationalservices" className="bg-white text-black py-24 md:py-36">
      <div className="container mx-auto px-6 md:px-10">
        {}
        <div ref={header.ref} className={`grid grid-cols-12 gap-6 md:gap-10 mb-20 md:mb-28 transition-all duration-1000 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="col-span-12 md:col-span-3">
            <span className="font-sans text-xs uppercase tracking-[0.25em] text-gray-500">
              03 — Layanan
            </span>
          </div>
          <div className="col-span-12 md:col-span-9 lg:col-span-8">
            <h2 className="font-default text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.05] text-black">
              Zona <em className="italic text-orange-600">Organisasi</em>
            </h2>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10 mb-10 md:mb-12">
          {primaryServices.map((service, i) => {
          const Icon = service.Icon;
          return <article data-index={i} key={service.title} className={`group bg-white text-black border border-gray-200 rounded-lg p-8 md:p-10 transition-all duration-500 ease-out hover:-translate-y-1 hover:shadow-md flex flex-col ${i === 1 ? "md:mt-[60px]" : ""}`}>
                <div className="flex items-center justify-between mb-10">
                  <Icon className="w-10 h-10 text-orange-600" strokeWidth={1.25} />
                  <span className="font-default italic text-base text-gray-500 tracking-wide">
                    {service.numeral}
                  </span>
                </div>

                <h3 className="font-default text-2xl md:text-[1.75rem] leading-tight text-black mb-4">
                  {service.title}
                </h3>

                <p className="font-sans text-sm md:text-base text-gray-600 leading-relaxed mb-10">
                  {service.description}
                </p>

                <div className="mt-auto">
                  <Link to="/PancasilaYouthZonePage" className="inline-flex items-center gap-2 font-default italic text-base text-black group/link">
                    <span className="relative">
                      Selengkapnya
                      <span className="absolute left-0 -bottom-0.5 h-px w-0 bg-black transition-all duration-500 group-hover/link:w-full" />
                    </span>
                    <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover/link:translate-x-1" strokeWidth={1.5} />
                  </Link>
                </div>
              </article>;
        })}
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-10">
          {secondaryServices.map((service, i) => {
          const Icon = service.Icon;
          return <article data-index={i} key={service.title} className={`group bg-white text-black border border-gray-200 rounded-lg p-8 md:p-10 transition-all duration-500 ease-out hover:-translate-y-1 hover:shadow-md flex flex-col ${service.span}`}>
                <div className="flex items-center justify-between mb-10">
                  <Icon className="w-10 h-10 text-orange-600" strokeWidth={1.25} />
                  <span className="font-default italic text-base text-gray-500 tracking-wide">
                    {service.numeral}
                  </span>
                </div>

                <h3 className="font-default text-2xl md:text-[1.75rem] leading-tight text-black mb-4">
                  {service.title}
                </h3>

                <p className="font-sans text-sm md:text-base text-gray-600 leading-relaxed mb-10 max-w-xl">
                  {service.description}
                </p>

                <div className="mt-auto">
                  <Link to="/PancasilaYouthZonePage" className="inline-flex items-center gap-2 font-default italic text-base text-black group/link">
                    <span className="relative">
                      Selengkapnya
                      <span className="absolute left-0 -bottom-0.5 h-px w-0 bg-black transition-all duration-500 group-hover/link:w-full" />
                    </span>
                    <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover/link:translate-x-1" strokeWidth={1.5} />
                  </Link>
                </div>
              </article>;
        })}
        </div>
      </div>
    </section>;
}